import { Routes, Route, Navigate, Link, useParams } from 'react-router-dom';
import { ClientWorkspaceLayout, RedirectToClientSection } from './components/layout';
import {
  Businesses,
  Services,
  Keywords,
  Reviews,
  Reports,
  Content,
  Settings,
  ClientDetail,
  ClientAnalytics,
  ClientOptimization,
  Notifications,
  SharedClientReport,
} from './pages';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/businesses" replace />} />

      <Route element={<ClientWorkspaceLayout />}>
        {/* top-level */}
        <Route path="/businesses" element={<Businesses />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/notifications" element={<Notifications />} />

        {/* client workspace */}
        <Route path="/client/:id" element={<ClientIndexRedirect />} />
        <Route path="/client/:id/dashboard" element={<ClientDetail />} />
        <Route path="/client/:id/reviews" element={<Reviews />} />
        <Route path="/client/:id/services" element={<Services />} />
        <Route path="/client/:id/keywords" element={<Keywords />} />
        <Route path="/client/:id/content" element={<Content />} />
        <Route path="/client/:id/reports" element={<Reports />} />
        <Route path="/client/:id/analytics" element={<ClientAnalytics />} />
        <Route path="/client/:id/optimization" element={<ClientOptimization />} />

        {/* old flat → nested redirects */}
        <Route path="/reviews" element={<RedirectToClientSection section="reviews" />} />
        <Route path="/services" element={<RedirectToClientSection section="services" />} />
        <Route path="/keywords" element={<RedirectToClientSection section="keywords" />} />
        <Route path="/content" element={<RedirectToClientSection section="content" />} />
        <Route path="/reports" element={<RedirectToClientSection section="reports" />} />
      </Route>

      {/* PUBLIC — OUTSIDE the layout (no sidebar/topbar) */}
      <Route path="/client-report/:token" element={<SharedClientReport />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/** `/client/:id` with no section → that client's dashboard (explicit absolute path). */
function ClientIndexRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/client/${id}/dashboard`} replace />;
}

function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-300 mb-4">404</h1>
        <p className="text-lg text-gray-600 mb-8">Страница не найдена</p>
        <Link to="/businesses" className="text-primary-600 hover:text-primary-700">
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
}

export default App;
